<button nbButton status="primary" (click)="addEntry()" [disabled]="disabled">+ Hinzuf&uuml;gen</button>
<nb-list *ngIf="priceOverrides?.length >= 0" class="container-fluid mt-3">
  <nb-list-item *ngFor="let override of priceOverrides; let i = index" class="row">
    <div class="col-12 d-flex align-items-center mb-2">
      <input autocomplete="off"
             #serviceSelectInput
             nbInput
             fullWidth
             class="form-control"
             type="text"
             [ngModel]="getServiceNameBySelected(override)"
             (ngModelChange)="filterSelectOptions($event)"
             (focus)="filterSelectOptions('')"
             placeholder="Services durchsuchen..."
             [nbAutocomplete]="serviceList"
             [disabled]="disabled"
      >

      <nb-autocomplete #serviceList (selectedChange)="serviceSelectedChange($event, override)" >

        <nb-option *ngFor="let option of filteredDisplayServices$ | async" [value]="option.id">
          {{option.name}}
        </nb-option>

      </nb-autocomplete>
      <!--
    </div>
    <div class="col-3 d-flex justify-content-end">
    -->
      <button class="ml-4" nbButton status="danger" (click)="delete(i)" [disabled]="disabled">- L&ouml;schen</button>
    </div>
    <div class="col-6" style="border-right: var(--list-item-divider-width) var(--list-item-divider-style) var(--list-item-divider-color);">
      <label class="d-block">Preis / Einheit (&euro;)</label>
      <nb-checkbox [(ngModel)]="override.overridePricePerUnit" [disabled]="disabled">&Uuml;berschreiben?</nb-checkbox>
      <input *ngIf="override.overridePricePerUnit" nbInput type="number" class="form-control" [(ngModel)]="override.pricePerUnit" [disabled]="disabled">
    </div>
    <div class="col-6">
      <label class="d-block">min. Preis (&euro;)</label>
      <nb-checkbox [(ngModel)]="override.overrideMinPrice" [disabled]="disabled">&Uuml;berschreiben?</nb-checkbox>
      <input *ngIf="override.overrideMinPrice" nbInput type="number" class="form-control" [(ngModel)]="override.minPrice" [disabled]="disabled">
    </div>
  </nb-list-item>
</nb-list>
